<template>
  <StepperHeader :current="0" />
  <RegisterLayout>
    <template #description>
      <h2>¡Crea tu equipo de trabajo en minutos!</h2>
      <p>Ofrece una experiencia fluida y sin fisuras con comunicación omnicanal en la nube. 💪</p>

      <ul>
        <li><span>Accesibilidad desde cualquier lugar con conexión a internet.</span></li>
        <li>
          <span>
            Mejora de la eficiencia y productividad gracias a herramientas como enrutamiento
            inteligente de llamadas y reportes en tiempo real.
          </span>
        </li>
        <li>
          <span>
            Flexibilidad para ofrecer un servicio omnicanal, incluyendo chats y llamadas.</span
          >
        </li>
        <li>
          <span>
            Ahorro de costos al no tener que invertir en infraestructura y mantenimiento de
            servidores.
          </span>
        </li>
      </ul>
    </template>

    <template #form>
      <FormCard hide-img>
        <div class="container">
          <div class="container__email">
            <p class="email__success">Correo electrónico enviado</p>
            <p class="content__paragraph">
              Hemos enviado un correo de confirmación a <br />
              {{ email }}
            </p>
            <p class="help">
              ¿Te equivocastes de correo?

              <a-button class="button" type="link" @click="handleBack"> Haz click aquí. </a-button>
            </p>
          </div>
          <div class="image__register">
            <img src="@/app/register/assets/letter.png" alt="registro" />
          </div>
        </div>
      </FormCard>
    </template>
  </RegisterLayout>
</template>

<script>
import { defineComponent } from "vue";

import StepperHeader from "../header/StepperHeader.vue";
import RegisterLayout from "../layout/RegisterLayout.vue";
import FormCard from "@/app/auth/components/atoms/FormCard.vue";

export default defineComponent({
  components: {
    StepperHeader,
    RegisterLayout,
    FormCard,
  },
  setup() {
    return {
      subtitle: " ",
    };
  },
  computed: {
    email() {
      return this.$store.getters["getTemporalUserEmail"];
    },
  },
  methods: {
    handleBack() {
      this.$store.dispatch("removeTemporalUserFromStore");
    },
  },
});
</script>

<style lang="sass" scoped>
.content
  border: $border-normal
  max-width: $form-width-medium
  text-align: center
  margin: 32px auto
  border-radius: 2px
  padding: 32px 80px
  position: relative
  min-height: unset

  & > img
    display: block
    margin: 1rem auto


.container__email
  text-align: center

.email__success
  font-weight: 600
  font-size: 20px
  margin-bottom: 24px

.image__register
  margin-left: 10px
  transform: rotate(-9.36deg)

  & > img
    width: 200px

.container
  height: 100%
  width: 100%
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  gap: 50px
  color: $gray-9

.content__paragraph
  margin-bottom: 16px
  font-size: 16px

.button
  padding: 0

.help
  color: $gray-8
</style>
